export default __webpack_public_path__ + "static/media/FontOfficeLogo.62f9b19f.png";